// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__hj7PD","name":"style_name__QItHq"};